import { DataLayer } from "@sazka/utils/data-layer";

//DL2.30
const pushErrorPageVisit = (errorCode: string, errorText: string) => {
    DataLayer.push({
        page: {
            type: "error",
            kind: "error",
            error: {
                type: errorCode,
                message: errorText,
            },
        },
        event: "pageReady",
    });
};

//DL3.30
const pushErrorPageButtonClick = () => {
    DataLayer.push({ event: "action.clickHome.errorPage" });
};

document.ready(() => {
    const page = document.querySelector<HTMLElement>(".error-page");
    const errorCode = page?.dataset?.aErrorCode;
    if (!errorCode) {
        return;
    }

    const errorText =
        errorCode === "404"
            ? "Tady něco nehraje. Zkuste si vylosovat jinou stránku."
            : "Na serveru nastala chyba. Pracujeme na jejím odstranění.";

    pushErrorPageVisit(errorCode, errorText);

    const homepageLink = page.querySelector<HTMLElement>("#homepage-link");
    homepageLink?.addEventListener("click", () => pushErrorPageButtonClick());
});
